import { useMediaQuery } from 'react-responsive'

import { breakPoints, breakPointsPx } from '@/styles/breakpoints'

export enum MediaQueries {
  MOBILE = 'mobile',
  NOT_MOBILE = 'notMobile',
  TABLET = 'tablet',
  TABLET_OR_MOBILE = 'tabletOrMobile',
  NOT_DESKTOP = 'notDesktop',
  DESKTOP = 'desktop',
}

export interface MediaQueriesProps {
  mobile: string
  notMobile: string
  tablet: string
  tabletOrMobile: string
  notDesktop: string
  desktop: string
}

export const mediaQueries: MediaQueriesProps = {
  mobile: `@media only screen and (max-width: ${breakPoints.md - 1}px)`,
  notMobile: `@media only screen and (min-width: ${breakPointsPx.md})`,
  tablet: `@media only screen and (min-width: ${breakPointsPx.md}) and (max-width: ${breakPoints.lg - 1}px)`,
  tabletOrMobile: `@media only screen and (max-width: ${breakPoints.lg - 1}px)`,
  notDesktop: `@media only screen and (max-width: ${breakPoints.xl - 1}px)`,
  desktop: `@media only screen and (min-width: ${breakPointsPx.xl})`,
}

export const useSmallMobileMediaQuery = () => useMediaQuery({ maxWidth: breakPoints.sm - 1 })
export const useMobileMediaQuery = () => useMediaQuery({ maxWidth: breakPoints.md - 1 })
export const useIsNotMobileMediaQuery = () => useMediaQuery({ minWidth: breakPoints.md })
export const useTabletMediaQuery = () => useMediaQuery({ minWidth: breakPoints.md, maxWidth: breakPoints.lg - 1 })
export const useTabletOrMobileMediaQuery = () => useMediaQuery({ maxWidth: breakPoints.lg - 1 })
export const useDesktopMediaQuery = () => useMediaQuery({ minWidth: breakPoints.xl })
export const useLaptopOrDesktopMediaQuery = () => useMediaQuery({ minWidth: breakPoints.lg })

export const Desktop = ({ children }) => {
  const isDesktop = useDesktopMediaQuery()
  return isDesktop ? children : null
}
export const LaptopOrDesktop = ({ children }) => {
  const isLaptopOrDesktop = useLaptopOrDesktopMediaQuery()
  return isLaptopOrDesktop ? children : null
}
export const Tablet = ({ children }) => {
  const isTablet = useTabletMediaQuery()
  return isTablet ? children : null
}
export const Mobile = ({ children }) => {
  const isMobile = useMobileMediaQuery()
  return isMobile ? children : null
}

export const TabletOrMobile = ({ children }) => {
  const isTabletOrMobile = useTabletOrMobileMediaQuery()
  return isTabletOrMobile ? children : null
}
export const NotMobile = ({ children }) => {
  const isNotMobile = useIsNotMobileMediaQuery()
  return isNotMobile ? children : null
}
